import { Minus, Plus } from "lucide-react";
import { useEffect, useRef, useState } from "react";

function FaqItem({ question, answer, isOpen, onToggle }) {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <div onClick={onToggle} className={`px-8 py-7 transition-all duration-300`}>
      <button className="flex justify-between items-center w-full text-left gap-4">
        <h3 className="text-[20px] leading-[26px] font-semibold">{question}</h3>
        <span className="text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1">
          {isOpen ? <Minus size={20} /> : <Plus size={20} />}
        </span>
      </button>
      <div
        ref={contentRef}
        style={{
          maxHeight: `${height}px`,
          overflow: "hidden",
          transition: "max-height 0.3s ease, opacity 0.3s ease",
          opacity: isOpen ? 1 : 0,
        }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: answer }}
          className="mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
        ></div>
      </div>
    </div>
  );
}

function FaqList({ faqs }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <>
      {faqs.map((faq, index) => (
        <div
          className={` bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ${
            openIndex === index ? "" : "hover:bg-surface-dark"
          } transition-all  duration-300`}
          key={index}
        >
          <FaqItem
            key={index}
            question={faq?.question}
            answer={faq?.answer}
            isOpen={openIndex === index}
            onToggle={() => setOpenIndex(openIndex === index ? null : index)}
          />
        </div>
      ))}
    </>
  );
}

const FAQ2 = ({ faqData, heading, description }) => {
  return (
    <div className="md:w-[920px] max-w-full mx-auto">
      <h3 className="text-4xl md:text-5xl font-semibold leading-snug mb-8">
        {heading}
      </h3>
      {description && (
        <p className="text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12">
          {description}
        </p>
      )}
      <FaqList faqs={faqData} />
    </div>
  );
};

export default FAQ2;
